import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { Logger } from './logger.service';
import { LoggerConfig } from './models/logger.model';

const loggerServices = [Logger];
const loggerProvideValues = (config: LoggerConfig) => [{ provide: LoggerConfig, useValue: config }];
export const provideLogger: (config: LoggerConfig) => EnvironmentProviders = (config) => {
    const providers: Array<EnvironmentProviders | Provider> = [...loggerProvideValues(config), ...loggerServices];

    return makeEnvironmentProviders(providers);
};
